// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"206ebb50","317":"ffa8677a","734":"e294ed9d"}[chunkId] + ".chunk.js";
};